import React, { useState } from "react"
import { Button, Typography, Card, Flex, Input, message } from "antd"
import styles from "./index.module.css"
import logo from "assets/images/white-logo.png"
import { createEmail } from "store/clients"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
const { Title, Text } = Typography
const Splash = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState(false)
  const handleEmailChange = (e) => {
    const value = e.target.value.slice(0, 256) // optional: limit length to 256
    setEmail(value)

    const safeEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    setIsEmailValid(safeEmailRegex.test(value))
  }

  const handleClick = () => {
    if (isEmailValid) {
      setLoading(true)
      dispatch(createEmail({ email: email }))
        .then((res) => {
          if (res.message === "Email sent successfully") {
            message.success("Email sent successfully")
            setEmail("")
            setIsEmailValid(false)
          }
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src={logo} alt="Digital Sportsman Logo" className={styles.logoImg} />
      </div>
      <div className={styles.signInButton}>
          <Button type="primary" onClick={() => navigate("/auth/sign-in")}>
            Sign In
          </Button>
        </div>
      <Card bordered={false} className={styles.card}>
        <div className="mt-5xl">
          <Title level={1} className={styles.title}>
            YOUR NEXT ADVENTURE
            <br />
            IS ALMOST HERE
          </Title>
          <Text className={styles.subtitle}>
            We’re getting ready to launch the <b>Digital Sportsman Marketplace</b>—a new way to discover and book unforgettable outdoor
            experiences directly with local, trusted guides.
          </Text>
        </div>
        <Flex vertical gap={20} className={styles.info}>
          <div>
            <Text strong className={styles.infoTitle}>
              Be the first to know when we go live.
            </Text>
            <br />
            <Text className={styles.infoText}>Join our list and we’ll let you know as soon as the marketplace launches</Text>
          </div>

          <Input
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
            type="email"
            className={styles.emailInput}
            autocomplete="off"
          />

          <Button
            variant="filled"
            size="large"
            className={`${!isEmailValid ? styles.disabledBtn : ""} ${styles.activeBtn}`}
            disabled={!isEmailValid}
            onClick={handleClick}
          >
            {loading ? <div className={styles.loader}></div> : "JOIN NOW!"}
          </Button>
        </Flex>
      </Card>
    </div>
  )
}

export default Splash
